import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($rootScope, $scope, $stateParams, $timeout, $uibModalInstance, jsSdkPromo, jsSdkUser, metaTagService, tracking) {
  metaTagService.set({
    title: 'Enter Promo Code | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.error = '';

  $scope.form = {
    promoCode: $stateParams.code
  };

  $scope.isRedeemingPromo = null;
  $scope.redeemPromoResult = null;
  $scope.redeemPromoBtnOptions = {
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Redeem Promo',
    buttonSubmittingText: 'Redeeming Promo...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Promo Redeemed',
    buttonSuccessClass: 'btn-success',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Invalid Promo Code',
    buttonErrorClass: 'btn-danger'
  };

  $scope.resetFormValidation = function() {
    $scope.form.promoCode = '';
    $scope.promoCodeForm.$setPristine(); //reset validation
    $scope.submitted = false;
  };

  $scope.redeemPromoCode = function(promoCodeForm) {

    $scope.submitted = true;

    if (!promoCodeForm.$valid) return;

    $scope.isRedeemingPromo = true;
    $scope.redeemPromoResult = null;

    jsSdkPromo.redeem({
        code: $scope.form.promoCode
      })
      .then(function success(response) {
          $scope.errorMsg = null;
          $scope.resetFormValidation();

          $scope.redeemPromoResult = 'success';
          $scope.isRedeemingPromo = false;

          $scope.successMsg = response.message;

          jsSdkUser.me();

          tracking.trackEvent(SEGMENT_EVENTS.RedeemedPromoCode, {});
        },
        function error() {
          $scope.successMsg = null;
          $scope.errorMsg = 'Sorry that promo code is not valid';
          $scope.resetFormValidation();

          $scope.redeemPromoResult = 'error';
          $scope.isRedeemingPromo = false;
        });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$stateParams',
  '$timeout',
  '$uibModalInstance',
  'jsSdk.promo',
  'jsSdk.user',
  'metaTagService',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/services/modal/enterPromo/enterPromoModalCtrl.js